
import { isInspectMode } from '@/state/inspect'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NothingOnInspectMode',
  setup () {
    return {
      isInspectMode,
    }
  },
})
